import { render, staticRenderFns } from "./CompetitionUpdate.vue?vue&type=template&id=8fa2285e&scoped=true"
import script from "./CompetitionUpdate.vue?vue&type=script&lang=js"
export * from "./CompetitionUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa2285e",
  null
  
)

export default component.exports